module.exports = __webpack_public_path__ + "static/media/studentIcon.29775856.png";